import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';


const RawMaterialCat = ({ show, onClose, selectedId, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [rawmaterialcategory_name, setname] = useState('');
    const [description, setdescription] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        axios.get(`${baseURL}/rawmaterialcategory/${selectedId}`)
            .then(response => {
                setname(response.data.rawmaterialcategory_name);
                setdescription(response.data.description);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, []);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };
    
    const validate = () => {
        const newErrors = {};
        if (!rawmaterialcategory_name.trim()) {
            newErrors.name = "This Field is Required.";
            return newErrors;
        }

        const regex = /^[A-Za-z\s]+$/;
        if (!regex.test(rawmaterialcategory_name)) {
            newErrors.name = "Not a Valid Name";
            return newErrors;
        }

        return newErrors;
    };
    
    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { rawmaterialcategory_name, description };
        // Create a new post
        axios.put(`${baseURL}/rawmaterialcategory/${selectedId}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Raw Material Category Updated successfully!"); 
            });
    };

    return (
        <Modal show={show}  size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Raw Material Category</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Raw Material Category<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Raw Material Category"
                                    maxLength={100}
                                    value={rawmaterialcategory_name} 
                                    onChange={(e) => setname(formatName(e.target.value))} 
                                />
                                {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea rows={8} className="form-control h-auto" name="comment" placeholder="Description" 
                                    maxLength={255}
                                    value={description} 
                                    onChange={(e) => setdescription(formatName(e.target.value))} 
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary">Update Raw Material Category<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default RawMaterialCat;
